<div class="flex flex-row dots">
  <div class="left-container" style="padding-right: 10px">
    <ng-content select="[left]"></ng-content>
  </div>
  <ng-container [ngTemplateOutlet]="dotsStart" *ngIf="position == 'start'"></ng-container>
  <ng-container [ngTemplateOutlet]="dotsMiddle" *ngIf="position == 'middle'"></ng-container>
  <ng-container [ngTemplateOutlet]="dotsEnd" *ngIf="position == 'end'"></ng-container>
  <ng-container [ngTemplateOutlet]="dotsNone" *ngIf="position == 'none'"></ng-container>
  <div style="padding-left: 10px; width: 100%">
    <ng-content select="[right]"></ng-content>
  </div>
</div>

<ng-template #dotsNone>
  <div class="list-end">
    <div *ngIf="!noIcon" [ngClass]="iconSize" class="dot-icon"><i [class]="iconClass"></i></div>
  </div>
</ng-template>

<ng-template #dotsStart>
  <div class="list-end" style="margin-top: 10px">
    <div *ngIf="!noIcon" [ngClass]="iconSize" class="dot-icon"><i [class]="iconClass"></i></div>
    <div
      class="flex-grow-1"
      style="display: flex; justify-content: center; width: 50px; padding-top: 5px"
    >
      <div class="dotted-line"></div>
    </div>
  </div>
</ng-template>

<ng-template #dotsMiddle>
  <div class="list-end">
    <div class="flex-grow-1" style="display: flex; justify-content: center">
      <div class="dotted-line"></div>
    </div>
    <div *ngIf="noIcon && customIcon?.length > 0">
      <img src="assets/images/icons/svg/{{ customIcon }}" alt="icon" class="icon" />
    </div>
    <div *ngIf="!noIcon" [ngClass]="iconSize" class="dot-icon"><i [class]="iconClass"></i></div>
    <div class="flex-grow-1" style="display: flex; justify-content: center; width: 50px">
      <div class="dotted-line"></div>
    </div>
  </div>
</ng-template>

<ng-template #dotsEnd>
  <div class="list-end" style="margin-bottom: 20px !important">
    <div class="flex-grow-1" style="display: flex; justify-content: center">
      <div class="dotted-line"></div>
    </div>
    <div *ngIf="!noIcon" [ngClass]="iconSize" class="dot-icon"><i [class]="iconClass"></i></div>
  </div>
</ng-template>
